import React, { useEffect, useState } from 'react'
const TopBottomSizeSelector = ({ sortedSizes, sizeSelected, handleSizeSelected }) => {
    const [selectedTop, setSelectedTop] = useState(sizeSelected?.title?.split(' / ')[0]);
    const [selectedBottom, setSelectedBottom] = useState(sizeSelected?.title?.split(' / ')[1]);
    
    const topSizes = [...new Set(sortedSizes.map(item => item.title.split(' / ')[0]))];
    const bottomSizes = [...new Set(sortedSizes.map(item => item.title.split(' / ')[1]))];

    const handleSelection = (top, bottom) => {

        if (top && top !== selectedTop) setSelectedTop(top);
        if (bottom && bottom !== selectedBottom) setSelectedBottom(bottom);


        if (top && bottom && !selectedTop && !selectedBottom) {
            const selectedVariant = sortedSizes.find(
                item => item.title === `${top} / ${bottom}`
            );
            if (selectedVariant) {
                handleSizeSelected(selectedVariant);
            }
        }
    };


    useEffect(() => {
        if (selectedTop && selectedBottom) {
            const selectedVariant = sortedSizes.find(
                item => item.title === `${selectedTop} / ${selectedBottom}`
            );
            if (selectedVariant) {
                handleSizeSelected(selectedVariant);
            }
        }
    }, [selectedTop, selectedBottom, sortedSizes, handleSizeSelected]);

    return (
        <div>
            
            <div className="mb-4">
                <h3 className="text-lg font-bold">Top Size</h3>
                <div className="flex gap-2">
                    {topSizes.map((top, index) => (
                        <button
                            key={index}
                            className={`${selectedTop === top ? 'btn-primary' : 'btn-outline-primary'} w-full`}
                            onClick={() => handleSelection(top, selectedBottom)}
                        >
                            {top}
                        </button>
                    ))}
                </div>
            </div>

            
            <div className="mb-4">
                <h3 className="text-lg font-bold">Bottom Size</h3>
                <div className="flex gap-2">
                    {bottomSizes.map((bottom, index) => (
                        <button
                            key={index}
                            className={`${selectedBottom === bottom ? 'btn-primary' : 'btn-outline-primary'} w-full`}
                            onClick={() => handleSelection(selectedTop, bottom)}
                        >
                            {bottom}
                        </button>
                    ))}
                </div>
            </div>

        </div>
    );
};

export default TopBottomSizeSelector;